module.exports = __webpack_public_path__ + "media/images/nl/approve-82f83ae734b0014a4c758a7c0460638d.png";